import moment from 'moment';
import ElementClassHandler from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/element-class-handler';
import Selectors from '../../vendor/cdt/checkout/src/checkout-web/src/scripts/utils/selectors.js';

export default class {
    constructor(options = {}) {
        this.selectors = new Selectors({
            dataAttrId: 'data-delivery-selection-id'
        });
        this.elementIdentifier = options.elementIdentifier || '';
        this.validDeliveryCombinations = this.elementIdentifier + '_valid-delivery-combinations';
        this.dateSelection = this.elementIdentifier + '_date-selection';
        this.carrierSelection = this.elementIdentifier + '_carrier-selection';
        this.activeCarrierSelection = this.selectors.dataAttr(this.carrierSelection) + ' .active input';
        this.elementClassHandler = new ElementClassHandler;
        this.dateSelectionUISelect = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' select');
        this.dateSelectionUISelectOptions = this.dateSelectionUISelect.innerHTML;
        this.carrierSelectionUI = document.querySelector(this.selectors.dataAttr(this.carrierSelection) + ' select');
        this.carrierSelectionUIOptions = this.carrierSelectionUI.innerHTML;
    }

    setup() {
        this.getValidDeliveryCombinations();
        this.selectFirstAvailableDay();
        this.setupDateSelectionChangeListener();
        this.setupCarrierSelectionChangeListener();
        this.setCorrectCarrierSelectOptions();
        this.selectFirstAvailableCarrier();
    }

    getValidDeliveryCombinations() {
        let deliveryCombinations = document.querySelector(this.selectors.dataAttr(this.validDeliveryCombinations) + ' input');
        if (typeof deliveryCombinations.value === 'string') {
            this.validDeliveryCombinationValues = JSON.parse(deliveryCombinations.value);
        }
    }

    setupDateSelectionChangeListener() {
        let dateSelection = this.selectors.querySelectorArray(this.selectors.dataAttr(this.dateSelection) + ' input');
        if (dateSelection.length) {
            dateSelection.forEach(el => el.addEventListener('change', (e) => {
                e.preventDefault();
                this.setCorrectCarrierOptions(el.value);
                this.setCorrectCarrierSelectOptions();
                this.selectFirstAvailableCarrier();
            }));
        }
        if (this.dateSelectionUISelect) {
            this.dateSelectionUISelect.addEventListener('change', (e) => {
                e.preventDefault();
                let radioCheckTarget = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' input[value="' + this.dateSelectionUISelect.value + '"]');
                this.checkMaterialRadio(radioCheckTarget);
                this.setCorrectCarrierOptions(this.dateSelectionUISelect.value);
                this.selectFirstAvailableCarrier();
                this.setCorrectCarrierSelectOptions();
            });
        }
    }

    setupCarrierSelectionChangeListener() {
        let carrierOptions = this.selectors.querySelectorArray(this.selectors.dataAttr(this.carrierSelection) + ' input');
        if (carrierOptions.length) {
            carrierOptions.forEach(el => el.addEventListener('change', (e) => {
                e.preventDefault();
                this.carrierSelectionUI.innerHTML = this.carrierSelectionUIOptions;
                let chosenDate = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' input:checked').value,
                    carrierSelectOptions = this.selectors.querySelectorArray(this.selectors.dataAttr(this.carrierSelection) + ' select option'),
                    deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
                carrierSelectOptions.forEach((el) => {
                    if (!deliveryCarriersForDay.includes(parseInt(el.value))) {
                        el.parentNode.removeChild(el);
                    } else if (el.getAttribute('selected')) {
                        el.removeAttribute('selected');
                    }
                });
                document.querySelector(this.selectors.dataAttr(this.carrierSelection) + ' select').value = el.value;
            }));
        }
        if (this.carrierSelectionUI) {
            this.carrierSelectionUI.addEventListener('change', (e) => {
                e.preventDefault();
                let radioCheckTarget = document.querySelector(this.selectors.dataAttr(this.carrierSelection) + ' input[value="' + this.carrierSelectionUI.value + '"]');
                this.checkMaterialRadio(radioCheckTarget);
            });
        }
    }

    setCorrectCarrierOptions(chosenDate) {
        let carrierOptions = this.selectors.querySelectorArray(this.selectors.dataAttr(this.carrierSelection) + ' input'),
            deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
        carrierOptions.forEach((el) => {
            let formRow = el.parentElement.parentElement;
            if (deliveryCarriersForDay.includes(parseInt(el.value))) {
                this.elementClassHandler.add(formRow, 'active');
            } else {
                this.elementClassHandler.remove(formRow, 'active');
            }
        });
    }

    setCorrectCarrierSelectOptions() {
        this.carrierSelectionUI.innerHTML = this.carrierSelectionUIOptions;
        let chosenDate = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' input:checked').value,
            carrierOptions = this.selectors.querySelectorArray(this.selectors.dataAttr(this.carrierSelection) + ' select option'),
            deliveryCarriersForDay = this.validDeliveryCombinationValues[moment(chosenDate).format('E')];
        carrierOptions.forEach((el) => {
            if (!deliveryCarriersForDay.includes(parseInt(el.value))) {
                el.parentNode.removeChild(el);
            } else if (el.getAttribute('selected')) {
                el.removeAttribute('selected');
            }
        });
        this.selectFirstAvailableCarrier();
        this.dateSelectionUISelect.innerHTML = this.dateSelectionUISelectOptions;
        document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' select').value = chosenDate;
    }

    selectFirstAvailableDay() {
        let checkedDate = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' input:checked');
        if (!checkedDate) {
            checkedDate = document.querySelector(this.selectors.dataAttr(this.dateSelection) + ' input');
            checkedDate.checked = true;
        }

        if (checkedDate.length !== null) {
            this.setCorrectCarrierOptions(checkedDate.value);
        }
    }

    selectFirstAvailableCarrier() {
        let carrier = document.querySelector(this.activeCarrierSelection + ':checked');
        if (!carrier) {
            carrier = document.querySelector(this.activeCarrierSelection);
        }
        this.checkMaterialRadio(carrier);
        let carrierSelect = document.querySelector(this.selectors.dataAttr(this.carrierSelection) + ' select option[value="' + carrier.value + '"]');
        if (carrierSelect) {
            carrierSelect.parentNode.value = carrier.value;
        }
    }

    checkMaterialRadio(elem) {
        elem.checked = true;
        if (elem !== null && typeof elem.parentNode.MaterialRadio !== 'undefined') {
            elem.parentNode.MaterialRadio.check();
        }
    }
}
